import React, { useState } from 'react'
import useMedia from 'use-media'

import ButtonGroup from '../../atoms/ApartmentCard/ButtonGroup'

import WebsiteButton from '../../atoms/ApartmentCard/WebsiteButton'
import PhoneButton from '../../atoms/ApartmentCard/PhoneButton'
import MapButton from '../../atoms/ApartmentCard/MapButton'

export default ({ website, phone, showPopup }) => {
  const isMobile = useMedia({ maxWidth: '767.9px' })
  const [show, setShow] = useState()

  const onClick = () => setShow(!show)

  return (
    <ButtonGroup>
      {!show ? <WebsiteButton website={website} /> : null}
      {!show && showPopup ? <MapButton onClick={showPopup} /> : null}
      {phone ? <PhoneButton phone={phone} show={show} onClick={isMobile ? null : onClick} /> : null}
    </ButtonGroup>
  )
}
